// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B_fy","placeholdersHeader":"styles_placeholdersHeader__3IDav","editorStyle":"styles_editorStyle__QrQEb","placeholdersBox":"styles_placeholdersBox__p7LaF"};